import { useEffect, useRef, useState } from "react";

/**
 * Smooth animated number using rAF interpolation.
 */
export default function AnimatedNumber({ value = 0, formatter = (n) => n, duration = 480 }) {
  const [display, setDisplay] = useState(value);
  const rafRef = useRef(null);
  const fromRef = useRef(value);

  useEffect(() => {
    const start = performance.now();
    const from = fromRef.current;
    const to = value;
    if (Math.abs(to - from) < 0.001) {
      setDisplay(to);
      fromRef.current = to;
      return;
    }
    const tick = (now) => {
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - t, 3);
      const v = from + (to - from) * eased;
      setDisplay(v);
      if (t < 1) rafRef.current = requestAnimationFrame(tick);
      else fromRef.current = to;
    };
    rafRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafRef.current);
  }, [value, duration]);

  return <>{formatter(display)}</>;
}
